import { Component } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatError } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PaymentPlanService } from '../../../services/payment-plan.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-discount-code-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatDividerModule,
    MatError,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    NgIf
  ],
  templateUrl: './discount-code-dialog.component.html',
  styleUrl: './discount-code-dialog.component.scss'
})
export class DiscountCodeDialogComponent {

  constructor(private paymentService: PaymentPlanService) { }
  isLoading = false;

  discountCodeFormControl: FormControl = new FormControl('', [Validators.required]);

  redirectToDiscountedPaymentPlan() {
    if (this.discountCodeFormControl.valid) {
      this.isLoading = true;
      const code = this.discountCodeFormControl.value;
      this.paymentService.createDiscountStripeUrl(code).subscribe({
        next: (url) => {
          document.location.href = url.url;
        },
        error: () => {
          this.isLoading = false;
          alert('Server error, contact support');
        }
      });
    }
  }

}
